import { createRouter, createWebHistory } from 'vue-router';
import middlewarePipeline from '@/router/middlewarePipeline.js';
import { loadLayoutMiddleware } from '@/router/middlewares/loadLayoutMiddleware.js';
import auth from '@/router/middlewares/auth';
import BlankPage from '@/pages/blank.vue';

const importedRoutes = import.meta.glob('./routes/*.js', { import: 'default', eager: true });

const routes = [];
for (const routeFiles in importedRoutes) {
  // No Promises since it's eager loaded.
  routes.push(...importedRoutes[routeFiles]);
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  linkActiveClass: 'active',
  routes
});

router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next();
  }
  const middleware = to.meta.middleware;
  // console.log('middleware', middleware)
  const context = {
    to,
    from,
    next
  };

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  });
});

router.beforeEach(loadLayoutMiddleware);

export default router;
